// 所属服务 serviceTool 业务工具,publicTool 公共工具
const service = "serviceTool";
// 前台路由
const web_routers = {
  path: "bi",
  name: "webBi",
  component: {
    render: (e) => e("router-view"),
  },
  redirect: { name: "biIndex" },
  meta: {
    title: "门户服务",
    showFoot: false,
  },
  children: [
    {
      path: "index",
      name: "biIndex",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/Index.vue"
        ),
      meta: {
        title: "门户服务首页",
        showFoot: false,
      },
    },
    {
      path: "detail",
      name: "biDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../../lightApps/views/forestage/Detail.vue"
        ),
      meta: {
        title: "门户服务详情页",
        showHeader: false,
        showFoot: false,
        showAI: false,
      },
    },
    //文件暂时放在后台文件夹中，可能会在后台中预览查看
    {
      path: "indicatorWarningDetails",
      name: "indicatorWarningDetails",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/indicatorWarningDetails/IndicatorWarningDetails.vue"
        ),
      meta: {
        title: "预警详情",
        icon: "",
        headNav: false,
        layout: false,
      },
    },
    //文件暂时放在后台文件夹中，可能会在后台中预览查看
  ],
};
// 后台路由
const cms_routers = {
  path: "bi",
  name: "cmsBi",
  component: () =>
    import(
      /* webpackChunkName: "[request]" */ "../layouts/backstage/BiLayout.vue"
    ),
  redirect: { name: "targetGatherManagement" },
  meta: {
    title: "BI服务",
  },
  children: [
    {
      path: "targetGatherManagement",
      name: "targetGatherManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/targetGatherManagement/TargetGatherManagement.vue"
        ),
      meta: {
        title: "指标集管理",
        icon: "icon-shuju1",
      },
    },
    {
      path: "targetManagement",
      name: "targetManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/targetManagement/TargetManagement.vue"
        ),
      meta: {
        title: "指标管理",
        icon: "",
        head: false,
        layout: false,
      },
    },
    {
      path: "indicatorsDetails",
      name: "indicatorsDetails",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/indicatorsDetails/IndicatorsDetails.vue"
        ),
      meta: {
        title: "指标详情",
        icon: "",
        headNav: false,
        layout: false,
      },
    },
    {
      path: "targetDisplay",
      name: "targetDisplay",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/targetDisplay/Index.vue"
        ),
      meta: {
        title: "指标展示",
        icon: "",
        head: false,
        layout: false,
      },
    },
    {
      path: "visualApplication",
      name: "visualApplication",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/visualApplication/VisualApplication.vue"
        ),
      meta: {
        title: "可视化页面",
        icon: "icon-icon_wangye",
      },
    },
    {
      path: "visualApplicationManagement",
      name: "visualApplicationManagement",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/visualApplicationManagement/VisualApplicationManagement.vue"
        ),
      meta: {
        title: "可视化页面管理",
        icon: "",
        head: false,
        layout: false,
      },
    },
    {
      path: "visualApplicationDetail",
      name: "visualApplicationDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/visualApplicationDetail/VisualApplicationDetail.vue"
        ),
      meta: {
        title: "可视化页面预览",
        icon: "",
        headNav: false,
        layout: false,
      },
    },
    {
      path: "visualReport",
      name: "visualReport",
      component: { render: (e) => e("router-view") },
      redirect: { name: "reportManagement" },
      meta: {
        title: "可视化报告",
        icon: "icon-wendang",
      },
      children: [
        {
          path: "reportManagement",
          name: "reportManagement",
          component: () =>
            import(
              /* webpackChunkName: "[request]" */ "../views/backstage/reportManagement/ReportManagement.vue"
            ),
          meta: {
            title: "报告管理",
            icon: "",
          },
        },
        {
          path: "templateManagement",
          name: "templateManagement",
          component: () =>
            import(
              /* webpackChunkName: "[request]" */ "../views/backstage/templateManagement/TemplateManagement.vue"
            ),
          meta: {
            title: "模板管理",
            icon: "",
          },
        },
      ],
    },
    {
      path: "reportDraftbox",
      name: "reportDraftbox",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/reportDraftbox/ReportDraftbox.vue"
        ),
      meta: {
        title: "草稿箱",
        icon: "",
        layout: false,
      },
    },
    {
      path: "reportDeactivate",
      name: "reportDeactivate",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/reportDeactivate/ReportDeactivate.vue"
        ),
      meta: {
        title: "已停用",
        icon: "",
        layout: false,
      },
    },
    {
      path: "reportManagementEdit",
      name: "reportManagementEdit",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/reportManagementEdit/ReportManagementEdit.vue"
        ),
      meta: {
        title: "编辑报告",
        icon: "",
        head: false,
        layout: false,
      },
    },
    {
      path: "templateManagementEdit",
      name: "templateManagementEdit",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/templateManagementEdit/Index.vue"
        ),
      meta: {
        title: "编辑模板",
        icon: "",
        head: false,
        layout: false,
      },
    },
    {
      path: "reportLook",
      name: "reportLookIndex",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/backstage/reportLook/Index.vue"
        ),
      meta: {
        title: "查看报告",
        icon: "",
        head: false,
        layout: false,
      },
    },
  ],
};
export default {
  service,
  web: web_routers,
  cms: cms_routers,
};
